module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/hairstyle_02-f994a893b851ac92296dcf3c87fddcf8.webp";